import { useModuleContext } from '../../../modules/shared/moduleContext/useModuleContext.js';

export const useIsSelectedNavItem = (route: string) => {
  const {
    navigation: { useLocation },
  } = useModuleContext();

  const { pathname } = useLocation();

  return pathname?.includes(route);
};
